/**
 * Copyright (c) 2024-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

import { lazy } from 'react'

export const AuditList = lazy(() => import('./AuditList'))
export const BannerCreate = lazy(() => import('./BannerCreate'))
export const BannerEdit = lazy(() => import('./BannerEdit'))
export const BannerList = lazy(() => import('./BannerList'))
export const BannerLocationCreate = lazy(() => import('./BannerLocationCreate'))
export const BannerLocationEdit = lazy(() => import('./BannerLocationEdit'))
export const BannerLocationsList = lazy(() => import('./BannerLocationsList'))
export const BrandCreate = lazy(() => import('./BrandCreate'))
export const BrandEdit = lazy(() => import('./BrandEdit'))
export const BrandList = lazy(() => import('./BrandList'))
export const ContactMessageDetail = lazy(() => import('./ContactMessageDetail'))
export const ContactMessageList = lazy(() => import('./ContactMessageList'))
export const EncarteCreate = lazy(() => import('./EncarteCreate'))
export const EncarteEdit = lazy(() => import('./EncarteEdit'))
export const EncarteList = lazy(() => import('./EncarteList'))
export const FeatureFlagList = lazy(() => import('./FeatureFlagList'))
export const FrequentlyAskedQuestionCreate = lazy(() => import('./FrequentlyAskedQuestionCreate'))
export const FrequentlyAskedQuestionEdit = lazy(() => import('./FrequentlyAskedQuestionEdit'))
export const FrequentlyAskedQuestionList = lazy(() => import('./FrequentlyAskedQuestionList'))
export const HomeVisualBuilder = lazy(() => import('./HomeVisualBuilder'))
export const InstagramPostCreate = lazy(() => import('./InstagramPostCreate'))
export const InstagramPostEdit = lazy(() => import('./InstagramPostEdit'))
export const InstagramPostsList = lazy(() => import('./InstagramPostsList'))
export const LandingPageList = lazy(
  () =>
    import(
      '../modulos/conteudo/landingPages/listagem/components/LandingPageList/LandingPageList'
    ),
)
export const LandingPageEditor = lazy(
  () =>
    import(
      '../modulos/conteudo/landingPages/editor/components/LandingPageEditor/LandingPageEditor'
    ),
)
export const LandingPageAnalytics = lazy(
  () =>
    import(
      '../modulos/conteudo/landingPages/analytics/components/LandingPageAnalytics/LandingPageAnalytics'
    ),
)
export const EmailMarketingList = lazy(
  () =>
    import(
      '../modulos/conteudo/emailMarketing/listagem/components/EmailMarketingList/EmailMarketingList'
    ),
)
export const EmailMarketingEditor = lazy(
  () =>
    import(
      '../modulos/conteudo/emailMarketing/editor/components/EmailMarketingEditor/EmailMarketingEditor'
    ),
)
export const WorkWithUsEdit = lazy(() => import('./WorkWithUsEdit'))
export const WorkWithUsList = lazy(() => import('./WorkWithUsList'))
export const Login = lazy(() => import('./Login'))
export const NotFound = lazy(() => import('./NotFound'))
export const OfferCategoryCreate = lazy(() => import('./OfferCategoryCreate'))
export const OfferCategoryEdit = lazy(() => import('./OfferCategoryEdit'))
export const OfferCategoryList = lazy(() => import('./OfferCategoryList'))
export const Overview = lazy(() => import('./Overview'))
export const PageCreate = lazy(() => import('./PageCreate'))
export const PageEdit = lazy(() => import('./PageEdit'))
export const PageList = lazy(() => import('./PageList'))
export const PostCreate = lazy(() => import('./PostCreate'))
export const PostEdit = lazy(() => import('./PostEdit'))
export const PostList = lazy(() => import('./PostList'))
export const ProductCategories = lazy(() => import('./ProductCategories'))
export const ProductEdit = lazy(() => import('./ProductEdit'))
export const ProductList = lazy(() => import('./ProductList'))
export const ProductOfferCreate = lazy(() => import('./ProductOfferCreate'))
export const ProductOfferEdit = lazy(() => import('./ProductOfferEdit'))
export const ProductOfferList = lazy(() => import('./ProductOfferList'))
export const ProductSectionEdit = lazy(() => import('./ProductSectionEdit'))
export const ProductSections = lazy(() => import('./ProductSections'))
export const RecipeEdit = lazy(() => import('./RecipeEdit'))
export const RecipeList = lazy(() => import('./RecipeList'))
export const StoreCreate = lazy(() => import('./StoreCreate'))
export const StoreEdit = lazy(() => import('./StoreEdit'))
export const StoreList = lazy(() => import('./StoreList'))
export const UserCreate = lazy(() => import('./UserCreate'))
export const UserEdit = lazy(() => import('./UserEdit'))
export const UserList = lazy(() => import('./UserList'))
export const VideoEdit = lazy(() => import('./VideoEdit'))
export const VideoList = lazy(() => import('./VideoList'))
export const VisualBuilder = lazy(() => import('./VisualBuilder'))
export const WorkWithUsSubmissionJob = lazy(() => import('./WorkWithUsSubmissionJob'))
export const WorkWithUsSubmissionsList = lazy(() => import('./WorkWithUsSubmissionsList'))
export const WorkWithUsCreate = lazy(() => import('./WorkWithUsCreate'))
export const WorkshopsList = lazy(() => import('./WorkshopsList'))
export const WorkshopEventEdit = lazy(() => import('./WorkshopEventEdit'))
export const WorkshopEventCreate = lazy(() => import('./WorkshopEventCreate'))
export const AdvancedActions = lazy(() => import('./AdvancedActions'))
export const JobRequests = lazy(() => import('./JobRequests'))
export const JobRequestDetail = lazy(() => import('./JobRequestDetail'))
export const JobRequestCreate = lazy(() => import('./JobRequestCreate'))
export const Logout = lazy(() => import('./Logout'))
export const ReportList = lazy(() => import('./ReportList'))
export const ReportDetail = lazy(() => import('./ReportDetail'))
export const OAuthCallback = lazy(() => import('./OAuthCallback'))
export const Passkeys = lazy(() => import('./Passkeys'))
export const TransparencyReports = lazy(() => import('./TransparencyReports'))
export const TransparencyReportEdit = lazy(() => import('./TransparencyReportEdit'))
export const TransparencyReportCreate = lazy(() => import('./TransparencyReportCreate'))
export const SuppliersTaxInformationList = lazy(() => import('./SuppliersTaxInformationList'))
export const SupplierTaxInformationDetail = lazy(() => import('./SupplierTaxInformationDetail'))
